import React, { useState, useCallback, useContext, useEffect } from 'react'
import styled, { ThemeContext } from 'styled-components'
// import { NavLink } from 'react-router-dom'
import { Text } from 'rebass'
import { BigNumber } from 'bignumber.js'

// utils
import { BIGNUMBER_FMT } from '../../../constants/bakery'
import { ArtworksProps } from '../../../constants/artwork'

// components
import { ButtonConfirmed } from '../../../components/Button'
import Loader from '../../../components/Loader'
import { AutoRow } from '../../../components/Row'
import BiddingModal from './BiddingModal'
import SellComboModal from '../../Restaurant/components/SellComboModal'
// import Value from '../../../components/Value/OnlyValue'

// hooks
import { useActiveWeb3React } from '../../../hooks'
// import useAllowanceERC721, { ARTWORK } from '../../../hooks/nft/useAllowanceERC721'
// import useApproveERC721, { GETARTWORKEXCHANGE } from '../../../hooks/nft/useApproveERC721'
import useApproveAllERC721 from '../../../hooks/nft/useApproveAllERC721'
import useModal from '../../../hooks/bakery/useModal'
import useSell  from '../../../hooks/nft/useSell'
import useBid from '../../../hooks/nft/useBidding'
import useUpdateBid from '../../../hooks/nft/useUpdateBid'
import useRevokeExchange from '../../../hooks/nft/useRevokeExchange'
import useApproveERC20 from '../../../hooks/nft/useApproveERC20'
import useBuy  from '../../../hooks/nft/useBuy'
import useApproveBid from '../../../hooks/nft/useApproveBid'
import { useAddPopup } from '../../../state/application/hooks'
import { useWalletModalToggle } from '../../../state/application/hooks'
import useUserBids  from '../../../hooks/nft/useUserBids'
import useUserAsks from '../../../hooks/nft/useUserAsks'
import useCancelBid from '../../../hooks/nft/useCancelBid'
import useSellTokenTo from '../../../hooks/nft/useSellTokenTo'
import useAuction from '../../../hooks/nft/useAuction'
import useMaxBidPrice from '../../../hooks/nft/useMaxBidPrice'
import { MARKETTYPE } from '../../../constants/bakery/nft'

import { stopPropagation } from '../../../utils/func'
import { useMarketLevel } from '../../../state/market/hooks'

const ArtworksCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 16px;
  background-color: ${({ theme }) => theme.bsBg15};
  border-radius: 28px;
  width: 276px;
  min-height: 513px;
  margin-bottom: 25px !important;
  text-decoration: none;
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) => theme.bsBg27};
    box-shadow: 0px 2px 10px rgba(171, 133, 115, 0.16);
  }
  margin-right: 12px;
  margin-left: 12px;
`

const IconArtwork = styled.img`
  display: block;
  width: 244px;
  height: 325px;
  border-radius: 18px;
`
const CardHead = styled.div`
  position: relative;
  width: 100%;
`
const CardFoot = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
`

const Title = styled.div`
  margin: 16px 0 20px 0;
  width: 100%;
  font-size: 16px;
  line-height: 22px;
  height: 44px;
  color: ${({ theme }) => theme.bsText14};
`

const ArtworkLevel = styled.div`
  display: flex;
  margin-bottom: 16px;
  width: 100%;
  height: 17px;
  justify-content: space-between;
`
const Button = styled(ButtonConfirmed)`
  border: none;
  font-size: 14px;
  width: 244px;
  height: 40px;
  border-radius: 10px;
  padding: 0;
`
const BalanceBtn = styled.div`
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  & > button {
    width: 112px;
  }
`
const PriceFlag = styled.div`
  position: absolute;
  top: 0px;
  left: -6px;
  display: flex;
  align-items: center;
  background: ${({ theme }) => theme.bsBg8};
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  box-shadow: ${({ theme }) => theme.darkMode ? 'none' : '0px 2px 8px rgba(47, 20, 0, 0.74)' };
  color: ${({ theme }) => theme.bsText1};
  font-family: Baloo Da;
  font-weight: 400;
  max-width: 100%;
  height: 28px;
  padding: 0 8px;
  z-index: 1;
  &:after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -6px;
    border-width: 3px;
    border-style: solid;
    border-color: ${({ theme }) => theme.bsBg9} ${({ theme }) => theme.bsBg9} transparent transparent;
  }
`
// const ValueItem = styled.div`
//   font-size: 18px;
//   max-width: 200px;
// `
// const Bake = styled(Text)`
//   color: ${({ theme }) => theme.bsText9};
// `

export default function Artworks({artwork, isMyArtwork, bakeBalance = 0, allowanceBuy, history, allowanceBid, allowanceSellAll}: {artwork: ArtworksProps, isMyArtwork?: boolean, bakeBalance?: number, allowanceBuy?: BigNumber, allowanceBid?: BigNumber, history: any, allowanceSellAll?: boolean}) {
  const level = useMarketLevel()
  const theme = useContext(ThemeContext)
  const { library, account } = useActiveWeb3React()
  const addPopup = useAddPopup()
  const toggleWalletModal = useWalletModalToggle()
  const url = '/exchange/digital-artworks/artworkInfo/' + artwork.tokenId + '/' + (isMyArtwork ? '1' : '0')

  // 获取我的竞价
  const [isGetIds, setIsGetIds] = useState(false)
  const [requestedBid, setRequestedBid] = useState(false)
  const getBids = useUserBids(MARKETTYPE.BTCARTWORK)
  const emptyBids: any[] = []
  const [ids, setIds] = useState(emptyBids)
  const getIds = useCallback(async() => {
    const bids = await getBids()
    if (bids.length) {
      const bidsId = bids.map((d: any) => {
        return d[0]
      })
      setIds(bidsId)
    }
    setIsGetIds(true)
  }, [getBids])

  // 获取我的挂单
  const getAsks = useUserAsks(MARKETTYPE.BTCARTWORK)
  const emptyAsks: any[] = []
  const [aksIds, setAskIds] = useState(emptyAsks)
  const getAskIds = useCallback(async() => {
    const asks = await getAsks()
    if (asks.length) {
      const asksId = asks.map((d: any) => {
        return d[0]
      })
      setAskIds(asksId)
    }
  }, [getAsks])


  useEffect(() => {
    if (level === 'v2' && account) {
      getIds()
      getAskIds()
    }
  }, [getBids, getIds, getAskIds, getAsks, level, account, requestedBid, artwork])


  // v2查询是否授权卖
  const [requestedApprovalAllExchange, setRequestedApprovalAllExchange] = useState(false)
  const onApproveSellAll = useApproveAllERC721(MARKETTYPE.BTCARTWORK, 'market')
  const handleApproveSellAll = useCallback(
    async (event) => {
      stopPropagation(event)
      try {
        setRequestedApprovalAllExchange(true)
        const txHash = await onApproveSellAll()
        if (!txHash) {
          setRequestedApprovalAllExchange(false)
        } else {
          setTimeout(() => {
            setRequestedApprovalAllExchange(false)
          }, 10000)
        }
      } catch (e) {
        console.log(e)
      }
    },
    [onApproveSellAll, setRequestedApprovalAllExchange]
  )
  // console.log('---allowanceSellAll---->', allowanceSellAll)

  /**
   * SELL Artwork
   */
  // Approve
  // const [requestedApprovalExchange, setRequestedApprovalExchange] = useState(false)
  // const [resetApproval, setResetApproval] = useState(false)
  // const allowanceSell = useAllowanceERC721({
  //   tokenId: artwork.tokenId,
  //   type: ARTWORK,
  //   requested: requestedApprovalExchange,
  //   reset: resetApproval
  // })

  // const onApproveSell = useApproveERC721(artwork.tokenId, GETARTWORKEXCHANGE)
  // const handleApproveSell = useCallback(
  //   async (event) => {
  //     stopPropagation(event)
  //     try {
  //       setRequestedApprovalExchange(true)
  //       const txHash = await onApproveSell()
  //       if (!txHash) {
  //         setRequestedApprovalExchange(false)
  //       } else {
  //         setTimeout(() => {
  //           setRequestedApprovalExchange(false)
  //         }, 10000)
  //       }
  //     } catch (e) {
  //       console.log(e)
  //     }
  //   },
  //   [onApproveSell, setRequestedApprovalExchange]
  // )

  // Order
  const { onSell } = useSell(artwork.tokenId, MARKETTYPE.BTCARTWORK)
  const [artworkExchange] = useModal(
    <SellComboModal
      onConfirm={onSell}
      tokenName="BAKE"
      title="Please set the selling price"
    />,
  )
   
  // Auction
  const { onAuction } = useAuction(artwork.tokenId, artwork.nftType?.toString())
  const [auctionkExchange] = useModal(
    <SellComboModal
      onConfirm={onSell}
      tokenName="BAKE"
      title="Please set the opening price"
      type="Auction"
      onAuction={onAuction}
    />,
  )

  const onPresentExchange = useCallback(async (event, type) => {
    stopPropagation(event)
    if (type === 'sell') {
      artworkExchange()
    } else if (type === 'Auction') {
      auctionkExchange()
    }
  }, [artworkExchange, auctionkExchange])

  // Revoke
  const { onRevokeExchange } = useRevokeExchange(artwork.tokenId, MARKETTYPE.BTCARTWORK)
  const [requestedRevoke, setRequestedRevoke] = useState(false)
  const handleRevoke = useCallback(async (event) => {
    stopPropagation(event)
    try {
      setRequestedRevoke(true)
      const txHash = await onRevokeExchange()
      if (!txHash) {
        setRequestedRevoke(false)
      } else {
        // reset allowanceSell
        // setResetApproval(true)
        setTimeout(() => {
          setRequestedRevoke(false)
          // setResetApproval(false)
        }, 10000)
      }
    } catch (e) {
      console.log(e)
    }
  }, [onRevokeExchange])

  /**
   * BUY Artwork
   */
  // Approve
  const [requestedApprovalBuy, setRequestedApprovalBuy] = useState(false)
  const onApproveBuy = useApproveERC20(MARKETTYPE.BTCARTWORK)
  const handleApproveBuy = useCallback(async (event) => {
    stopPropagation(event)
    try {
      setRequestedApprovalBuy(true)
      const txHash = await onApproveBuy()
      if (!txHash) {
        setRequestedApprovalBuy(false)
      }
    } catch (e) {
      console.log(e)
    }
  }, [onApproveBuy, setRequestedApprovalBuy])
  
  // Buy
  const [requestedBuy, setRequestedBuy] = useState(false)
  const { onBuy } = useBuy(artwork.tokenId, MARKETTYPE.BTCARTWORK)
  const buyArtwork = useCallback(async (event) => {
    stopPropagation(event)
    try {
      setRequestedBuy(true)
      const txHash = await onBuy()
      if (!txHash) {
        setRequestedBuy(false)
      } else {
        // Seccussful
        if (!library) return
        library
          .getTransactionReceipt(txHash.transactionHash)
          .then(receipt => {
            if (receipt) {
              addPopup(
                {
                  txn: {
                    hash: txHash.transactionHash,
                    success: receipt.status === 1,
                    summary: 'Buy Digital Artwork NFT'
                  }
                },
                txHash.transactionHash
              )
            }
          })
          .catch(error => {
            console.error(`failed to check transaction hash: ${txHash.transactionHash}`, error)
          })
      }
    } catch (e) {
      console.log(e)
    }
  }, [onBuy, library, addPopup])

  const nextInfo = useCallback(() => {
    history.push(url)
  }, [history, url])

  const connectWallet = useCallback(async (event) => {
    stopPropagation(event)
    toggleWalletModal()
  }, [toggleWalletModal])

  /**
   * BID Artwork
   */
  //Approve
  const [requestedApprovalBid, setRequestedApprovalBid] = useState(false)
  const onApproveBid = useApproveBid(MARKETTYPE.BTCARTWORK)
  const handleApproveBid = useCallback(async (event) => {
    stopPropagation(event)
    try {
      setRequestedApprovalBid(true)
      const txHash = await onApproveBid()
      if (!txHash) {
        setRequestedApprovalBid(false)
      }
    } catch (e) {
      console.log(e)
    }
  }, [onApproveBid, setRequestedApprovalBid])

  // 竞价
  const handBid = ((event: any) => {
    stopPropagation(event)
    if (ids.includes(artwork.tokenId)) {
      onUpdateBid()
      return
    }
    if (aksIds.includes(artwork.tokenId)) {
      onLookBidding()
    } else {
      onBidding()
    }
  })
  // 将token卖给指定地址
  const {onSellBid} = useSellTokenTo(artwork.tokenId, MARKETTYPE.BTCARTWORK) 
  const onSellTokenTo = useCallback(async (address: string) => {
    try {
      const txHash = await onSellBid(address)
      console.log(txHash)
    } catch (e) {
      console.log(e)
    }
  }, [onSellBid])

  // Bidding
  const {onBid} = useBid(artwork.tokenId, MARKETTYPE.BTCARTWORK) 
  const {onMaxBidPrice} = useMaxBidPrice(artwork.tokenId, artwork.nftType)
  const handleBid = useCallback(async (amount: string) => {
    try {
      const txHash = await onBid(amount)
      txHash && artwork.auctionPrice && await onMaxBidPrice(new BigNumber(amount).div(new BigNumber(10).pow(18)).toString())
      if (txHash) {
        setRequestedBid(true)
      }
    } catch (e) {
      console.log(e)
    }
  }, [onBid, onMaxBidPrice, artwork])
  const [bidding] = useModal(
    <BiddingModal
      onSellTokenTo={onSellTokenTo}
      onConfirm={handleBid}
      isBidding={true}
      artist={artwork.author}
      name={artwork.name}
      tokenId={artwork.tokenId}
      type={MARKETTYPE.BTCARTWORK}
      auctionPrice={artwork.auctionPrice}
      />,
  )
  const onBidding = useCallback(async () => {
    bidding()
  }, [bidding])

  // 查看竞价列表
  const [lookBidding] = useModal(
    <BiddingModal
      onConfirm={onBid}
      onSellTokenTo={onSellTokenTo}
      isBidding={false}
      artist={artwork.author}
      name={artwork.name}
      tokenId={artwork.tokenId}
      type={MARKETTYPE.BTCARTWORK}
      auctionPrice={artwork.auctionPrice}
      />,
  )
  const onLookBidding = useCallback(async () => {
    lookBidding()
  }, [lookBidding])

  // 更新竞价
  const {onUpdate} = useUpdateBid(artwork.tokenId, MARKETTYPE.BTCARTWORK, artwork.auctionPrice ? onMaxBidPrice : '')
  const [updateBid] = useModal(
    <BiddingModal
      onSellTokenTo={onSellTokenTo}
      onConfirm={onUpdate}
      isBidding={true}
      artist={artwork.author}
      name={artwork.name}
      tokenId={artwork.tokenId}
      type={MARKETTYPE.BTCARTWORK}
      auctionPrice={artwork.auctionPrice}
      />,
  )
  const onUpdateBid = useCallback(async () => {
    updateBid()
  }, [updateBid])

  // 移除竞价
  const cancelBid = useCancelBid(artwork.tokenId, MARKETTYPE.BTCARTWORK)
  const [requestedCancel, setRequestedCancel] = useState(false)
  const onCancelBid = useCallback(async(event) => {
    stopPropagation(event)
    try {
      setRequestedCancel(true)
      const txHash = await cancelBid()
      if (!txHash) {
        setRequestedCancel(false)
      } else {
        setTimeout(() => {
          setRequestedCancel(false)
        }, 10000)
      }
    } catch (e) {
      console.log(e)
    }
  }, [cancelBid])

  return (
    <ArtworksCard onClick={nextInfo} className='fourItem'>
      {/* {
        level !== 'v1' && isMyArtwork && artwork.price && !ids.includes(artwork.tokenId) && <PriceFlag>
          <ValueItem>
              <Value decimals={0} value={new BigNumber(artwork.auctionPrice || artwork.price).integerValue(BigNumber.ROUND_CEIL).toFormat(0, BIGNUMBER_FMT)} />
            </ValueItem>
            <Bake fontSize={12} marginLeft={'5px'} marginTop={'2px'}>{'BAKE'}</Bake>
        </PriceFlag>
      } */}
      {
        level !== 'v1' && isGetIds && !ids.includes(artwork.tokenId) && Number(artwork.price) > 0 && <PriceFlag>
          <Text>{!artwork.auctionPrice ? 'On Sale' : 'On Auction'}</Text>
        </PriceFlag>
      }
      {
        level !== 'v1' && isGetIds && ids.includes(artwork.tokenId) && <PriceFlag>
          <Text>{Number(artwork.price) > 0 ? 'Offer made' : 'Order cancelled'}</Text>
        </PriceFlag>
      }
      <CardHead>
        <IconArtwork src={artwork.attributes.image_min} alt="" />
      </CardHead>
      <CardFoot>
        <Title>
          {artwork.name}
        </Title>
        {/* {
          (level === 'v1' || !isMyArtwork) ?
            <ArtworkLevel>
              <Text fontSize={14} color={theme.bsText5}>Price:</Text>
              <Text fontSize={14} fontWeight={700} color={theme.bsText14}>{artwork.price ? (new BigNumber(!artwork.auctionPrice ? artwork.price : artwork.auctionPrice).integerValue(BigNumber.ROUND_CEIL).toFormat(0, BIGNUMBER_FMT) + ' BAKE') : '-'}</Text>
            </ArtworkLevel>
          : null
        } */}
        <ArtworkLevel>
          <Text fontSize={14} color={theme.bsText5}>Price:</Text>
          <Text fontSize={14} fontWeight={700} color={theme.bsText14}>{artwork.price ? (new BigNumber(!artwork.auctionPrice ? artwork.price : artwork.maxBidPrice).integerValue(BigNumber.ROUND_CEIL).toFormat(0, BIGNUMBER_FMT) + ' BAKE') : '-'}</Text>
        </ArtworkLevel>
        {
          account ? (
            artwork.level === 'v1' ? 
              isMyArtwork
                ?  artwork.price ? (
                  <Button
                    disabled={requestedRevoke}
                    onClick={handleRevoke}
                    altDisabledStyle={requestedRevoke}
                  >
                    { 
                      requestedRevoke ? (
                        <AutoRow gap="6px" justify="center">
                          Revoking <Loader stroke="white" />
                        </AutoRow>
                      ) : (
                        'Revoke'
                      )
                    }
                  </Button>
                ) : 
                allowanceSellAll ? (
                  <Button 
                    onClick={event => {onPresentExchange(event, 'sell')}}
                  >Sell</Button>
                  // <BalanceBtn>
                  //   <Button
                  //     onClick={handBid}
                  //     style={{
                  //       marginRight: 16,
                  //       background: theme.bg1,
                  //       border: `1px solid ${theme.bsText2}`,
                  //       color: theme.bsText2
                  //     }}
                  //   >
                  //     Bidding
                  //   </Button>
                  //   <Button 
                  //     onClick={onPresentExchange}
                  //   >Sell</Button>
                  // </BalanceBtn>
                ) : (
                  <Button
                    onClick={handleApproveSellAll}
                    disabled={requestedApprovalAllExchange}
                    fontSize={14}
                    height={40}
                    altDisabledStyle={requestedApprovalAllExchange}
                  >
                    {requestedApprovalAllExchange ? (
                      <AutoRow gap="6px" justify="center">
                        Approving <Loader stroke="white" />
                      </AutoRow>
                    ) : (
                      'Approve NFT Marketplace'
                    )}
                  </Button>
                )
                // allowanceSell ? (
                //     <Button
                //       onClick={onPresentExchange}
                //     >Sell on Exchange</Button>
                //   ) : (
                //     <Button
                //       onClick={handleApproveSell}
                //       disabled={requestedApprovalExchange}
                //       fontSize={14}
                //       height={40}
                //       altDisabledStyle={requestedApprovalExchange}
                //     >
                //       {requestedApprovalExchange ? (
                //         <AutoRow gap="6px" justify="center">
                //           Approving <Loader stroke="white" />
                //         </AutoRow>
                //       ) : (
                //         'Approve NFT Marketplace'
                //       )}
                //     </Button>
                //   )
                : artwork.price !== undefined && new BigNumber(bakeBalance).lt(artwork.price) ? (
                  <Button
                    disabled={true}
                    altDisabledStyle={true}
                  >Insufficient BAKE balance</Button>
                ) : allowanceBuy?.toNumber() ? (
                    requestedBuy ? (
                      <Button
                        onClick={buyArtwork}
                        disabled={requestedBuy}
                        altDisabledStyle={requestedBuy}
                      >
                        <AutoRow gap="6px" justify="center">
                          Pending <Loader stroke="white" />
                        </AutoRow>
                      </Button>
                    ) : (
                        <Button
                          onClick={buyArtwork}
                          disabled={requestedBuy}
                          altDisabledStyle={requestedBuy}
                        >
                          Buy this Artwork
                        </Button>
                    )
                ) : (
                  <Button
                    onClick={handleApproveBuy}
                    disabled={requestedApprovalBuy}
                    altDisabledStyle={requestedApprovalBuy}
                  >
                    {
                      requestedApprovalBuy ? (
                        <AutoRow gap="6px" justify="center">
                          Approving <Loader stroke="white" />
                        </AutoRow>
                      ) : 'Approve NFT Marketplace'
                    }
                  </Button>
                )
              : isMyArtwork
              ? ids.includes(artwork.tokenId) 
                ? <BalanceBtn>
                    <Button
                      onClick={handBid}
                      style={{
                        marginRight: 16,
                        background: theme.bg1,
                        border: `1px solid ${theme.bsText7}`,
                        color: theme.bsText7
                      }}
                    >
                      update
                    </Button>
                    <Button
                      disabled={requestedCancel}
                      onClick={onCancelBid}
                      altDisabledStyle={requestedCancel}
                    >
                      { 
                        requestedCancel ? (
                          <AutoRow gap="6px" justify="center">
                            Pending <Loader stroke="white" />
                          </AutoRow>
                        ) : (
                          'Cancel'
                        )
                      }
                    </Button>
                  </BalanceBtn>
                : artwork.price ? (
                  <BalanceBtn>
                    <Button
                      onClick={handBid}
                      style={{
                        marginRight: 16,
                        background: theme.bg1,
                        border: `1px solid ${theme.bsText7}`,
                        color: theme.bsText7
                      }}
                    >
                      {!artwork.auctionPrice ? 'Bidding' : 'Auctioning'}
                    </Button>
                    <Button
                      disabled={requestedRevoke}
                      onClick={handleRevoke}
                      altDisabledStyle={requestedRevoke}
                    >
                      { 
                        requestedRevoke ? (
                          <AutoRow gap="6px" justify="center">
                            Revoking <Loader stroke="white" />
                          </AutoRow>
                        ) : (
                          'Revoke'
                        )
                      }
                    </Button>
                  </BalanceBtn>
              ) : allowanceSellAll ? (
                <BalanceBtn>
                  <Button
                    onClick={event => {onPresentExchange(event, 'Auction')}}
                    style={{
                      marginRight: 16,
                      background: '#FFFDFA',
                      border: '1px solid #AC562A',
                      color: '#AC562A'
                    }}
                  >
                    Auction
                  </Button>
                  <Button
                    onClick={event => {onPresentExchange(event, 'sell')}}
                  >Sell</Button>
                </BalanceBtn>
                  // <BalanceBtn>
                  //   <Button
                  //     onClick={handBid}
                  //     style={{
                  //       marginRight: 16,
                  //       background: theme.bg1,
                  //       border: `1px solid ${theme.bsText2}`,
                  //       color: theme.bsText2
                  //     }}
                  //   >
                  //     Bidding
                  //   </Button>
                  //   <Button 
                  //     onClick={onPresentExchange}
                  //   >Sell</Button>
                  // </BalanceBtn>
                ) : (
                  <Button
                    onClick={handleApproveSellAll}
                    disabled={requestedApprovalAllExchange}
                    fontSize={14}
                    height={40}
                    altDisabledStyle={requestedApprovalAllExchange}
                  >
                    {requestedApprovalAllExchange ? (
                      <AutoRow gap="6px" justify="center">
                        Approving <Loader stroke="white" />
                      </AutoRow>
                    ) : (
                      'Approve NFT Marketplace'
                    )}
                  </Button>
                )
              : artwork.price !== undefined && new BigNumber(bakeBalance).lt(!artwork.auctionPrice ? artwork.price : artwork.auctionPrice) ? (
                <Button
                  disabled={true}
                  altDisabledStyle={true}
                >Insufficient BAKE balance</Button>
              ) : (allowanceBuy?.toNumber() && allowanceBid?.toNumber()) ? (
                  requestedBuy ? (
                    <Button
                      onClick={buyArtwork}
                      disabled={requestedBuy}
                      altDisabledStyle={requestedBuy}
                    >
                      <AutoRow gap="6px" justify="center">
                        Pending <Loader stroke="white" />
                      </AutoRow>
                    </Button>
                  ) : (
                    (
                      !artwork.auctionPrice ? (
                        <BalanceBtn>
                          <Button
                            onClick={handBid}
                            style={{
                              marginRight: 16,
                              background: '#FFFDFA',
                              border: '1px solid #AC562A',
                              color: '#AC562A'
                            }}
                          >
                            Bidding
                          </Button>
                          <Button
                            onClick={buyArtwork}
                            disabled={requestedBuy || ids.includes(artwork.tokenId)}
                            altDisabledStyle={requestedBuy || ids.includes(artwork.tokenId)}
                          >{
                            requestedBuy ? (
                              <AutoRow gap="6px" justify="center">
                                Pending <Loader stroke="white" />
                              </AutoRow>
                            ) : 'Buy'
                          }</Button>
                        </BalanceBtn>
                      ) : (
                        <Button
                          onClick={handBid}
                          width={240}
                        >
                          Bidding
                        </Button>
                      )
                    )
                  )
              ) : (
                <Button
                  onClick={handleApproveBid}
                  disabled={requestedApprovalBid}
                  altDisabledStyle={requestedApprovalBid}
                >
                  {
                    requestedApprovalBid ? (
                      <AutoRow gap="6px" justify="center">
                        Approving <Loader stroke="white" />
                      </AutoRow>
                    ) : 'Approve NFT Marketplace'
                  }
                </Button>
              )
            ) : (
              <Button
                onClick={event => connectWallet(event)}>
                Connect Wallet
              </Button>
            )
        }
      </CardFoot>
    </ArtworksCard>
  )
}
